
import Vue, { PropType } from "vue";
import ProjectDetailsOverlay from "@/components/ProjectDetailsOverlay.vue";
import ProjectData from "@/data/ProjectData";

export default Vue.extend({
  name: "ProjectsList",
  components: {
    ProjectDetailsOverlay,
  },
  props: {
    projects: {
      type: Array as PropType<ProjectData[]>,
      default: () => [] as ProjectData[],
    },
  },
  data: function () {
    return {
      showPopup: false,
      popupTitle: "",
      popupColor: "",
      popupContent: "",
    };
  },
  methods: {
    showDetails: function (item: any) {
      this.popupTitle = item.name;
      this.popupColor = item.accentColor;
      this.popupContent = item.htmlDescription;
      this.showPopup = true;
      window.scrollTo(0, 0);
    },
    isVideo(url: string) {
      return url && url.toLowerCase().endsWith(".mp4");
    },
  },
});
